<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_Categories"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">
              <b-row>
                <b-col sm=3>

                  <TreeProjectComponent :reloadTree="reloadTree" :iscategory="editCategories" class="treecomponent" :lang="lang.Tree"></TreeProjectComponent>
                </b-col>
                <b-col sm="3">
                  <div >
                      
                    <!-- <p>{{lang.infotext_1}}:</p>
                    <b-img id="image__category" class="category-image" src="" fluid alt="category image"></b-img> -->
                  </div><br>

                  <b-form-group label="">
                    <b-form-radio-group
                      id="radio-group-1"
                      v-model="selected"
                      :options="options"
                      
                      name="radio-options"
                    ></b-form-radio-group>
                  </b-form-group>


                  <div v-show="selected == 'update'">
                    <p>{{lang.infotext_2}}.</p>
                  
                    <b-form inline>

                      <b-form-input id="input-category-name-update" class="input-category-name-update" :state="inputStatus"  v-model="categoryNameUpdate" :placeholder="lang.placeholder_Create" aria-describedby="input-category-feedback" :disabled="disabled"></b-form-input>

                      
                      <b-form-invalid-feedback id="input-category-feedback">
                        {{lang.validinfo_3}}
                      </b-form-invalid-feedback>
                      <b-form-text id="input-live-help">{{lang.infotext_2}}: {{selectedTreeProjectItemObject.category}}</b-form-text>
                      
                      


                      </b-form><br> 

                       
                      <PermissionGroupComponent v-show="globalSettings.advancedPermissions == true && depth == 2" :lang="lang.PermissionGroups" :defaultSettings="{ groups: $store.getters.selectedTreeProjectItemObject.groups, isId: true, parent: 'categories' }"></PermissionGroupComponent>
                    
                    
                    <br>
                    <b-button
                      class="btn update-button"
                      size="sm"
                      :variant="variant"
                      @click="updateCategory" >{{lang.button_Update}}
                    </b-button>
                  </div>  


<!-- ###############################3 -->

                  <div v-show="selected == 'new'">
                    <p>{{lang.infotext_5}}:</p>
                    <b-form inline>

                      <b-form-input id="input-category-name" class="input-category-name" :state="inputStatus"  v-model="categoryName" :placeholder="lang.placeholder_Create" aria-describedby="input-category-feedback"></b-form-input>

                      
                      <b-form-invalid-feedback id="input-category-feedback">
                        {{lang.validinfo_1}}
                      </b-form-invalid-feedback>
                      <b-form-text id="input-live-help">{{lang.infotext_2}}: {{selectedTreeProjectItemObject.category}}</b-form-text>
                      
                    


                    </b-form><br>
                    <!-- <p>{{lang.infotext_3}}:</p>
                    <b-form-file
                      v-model="file"
                      :state = null
                      :placeholder= lang.placeholder_file
                      drop-placeholder="Drop file here..."
                      class="import-file"
                      accept="image/jpeg, image/png, image/gif, image/svg"
                      size="sm"

                    ></b-form-file> -->
                    <!-- <br><br>
                    <p>{{lang.infotext_6}}:</p>
                    <b-form-input id="input-category-template" class="input-category-template" v-model="partNumberTemplate" :placeholder="lang.placeholder_Template"></b-form-input>
                    <br>-->

                    <PermissionGroupComponent v-show="globalSettings.advancedPermissions == true && depth == 1" :isDisabled="depth == 1" :lang="lang.PermissionGroups" :defaultSettings="{ groups: basicGroupId, isId: true, parent: 'categories' }"></PermissionGroupComponent>
                    

                    <b-button
                      class="btn create-button"
                      size="sm"
                      :variant="variant"
                      @click="createCategory" >{{lang.button_Create}}
                    </b-button> 
                  </div> 
                  <!-- <hr>
                  <p>{{lang.infotext_7}}</p>
                  <p class="info-template"># - {{lang.infotext_8}}<br>
                  {{lang.infotext_9}}<br>
                  ### - {{lang.infotext_10}}<br><br>
                  $ - {{lang.infotext_11}}<br>
                  {{lang.infotext_9}}<br>
                  $$$ - {{lang.infotext_12}}</p> -->

                  
                  

                </b-col>
                
                



              </b-row>
                            

            </b-container>
            
          </b-tab>

        </b-tabs>



  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import TreeProjectComponent from "@/components/shared/TreeProjectComponent";
import PermissionGroupComponent from "@/components/shared/PermissionGroupComponent"


//import FormTableComponent from '@/components/shared/FormTableComponent'

export default {
  name: "Content",
  components: {
    TreeProjectComponent,
    PermissionGroupComponent

  },
  props:{
    lang: Object,

  },
  data () {
    return {
      selected: 'update',
      options: [
        { text: 'Update category', value: 'update' },
        { text: 'New category', value: 'new' },
        
      ],

      file: null,
      categoriesData: {},
      categoryName:"",
      categoryNameUpdate: "",
      partNumberTemplate: "",
      partNumberTemplateUpdate: this.$store.getters.selectedTreeProjectItemObject.partNumberTemplate,
      disabled: false,
      inputStatus: null,

      reloadTree: false,
      editCategories: true,
      objectData:{},
      objAlertSuccess: {
         text: this.lang.alert_success_create_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertError:{
        text:this.lang.alert_error_create_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      objAlertSuccessUpdate: {
         text: this.lang.alert_success_update_category,
          type: "success", //success, danger, warning, info
          time: 5 //sec.

      },
      objAlertErrorUpdate:{
        text:this.lang.alert_error_update_category,
          type: "danger", //success, danger, warning, info
          time: 5 //sec.
      },
      basicGroupId: []
    }
  },
  computed: {
    ...mapGetters({

      formDetailsData: 'formDetailsData',
      elementCategory: 'elementCategory',
      //projectCategoriesData: 'projectCategoriesData',
      selectedTreeProjectItemObject: 'selectedTreeProjectItemObject',
      globalSettings: 'globalSettings'
    }),
    depth() {
      return this.$store.getters.selectedTreeProjectItemObject.depth;
    },
    categoryId(){
      return this.$store.getters.selectedTreeProjectItemObject.categoryId
    },
    image(){
      return this.$store.getters.selectedTreeProjectItemObject.image;
    },
    categoryNameUpdateTree(){
      return this.$store.getters.selectedTreeProjectItemObject.name;
    },
    partNumberTemplateTree(){
      return this.$store.getters.selectedTreeProjectItemObject.partNumberTemplate;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    permissionGroup() {

      return this.$store.getters.permissionGroup
    }
  },
  created () {
    this.categoryNameUpdate = this.$store.getters.selectedTreeProjectItemObject.name;

    if (this.categoryNameUpdate == "All projects") {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    
    this.getGroups();
    //this.displayImageCategory();

  },

  updated() {
        
  },
  watch: {
    categoryId: function() {
      

      //this.displayImageCategory();
      this.categoryNameUpdate = this.$store.getters.selectedTreeProjectItemObject.name;
    },
    projectCategoriesData: function(newVal) {
     this.categoriesData = JSON.parse(newVal.data);


    },
    categoryName: function(newVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }

      
    },
    categoryNameUpdateTree: function(newVal){
      if (newVal == ""){
        this.inputStatus = null;
      }else{
        this.inputStatus = true;
      }
      
      if(newVal == "All projects"){
        this.disabled = true;
      }else{
        this.disabled = false;
      }
      
      this.categoryNameUpdate = newVal;
    },
    partNumberTemplateTree: function(newVal){
      
      
      this.partNumberTemplateUpdate = newVal;
    },
  },
  methods:{
    getGroups() {

      let _vue = this;
      this.basicGroupId = [];

      this.$store.dispatch("u_getGroups")
        .then(function (result) {

          console.log(result.data)

          if (result.status == "OK") {

            if (result.data != null) {


              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].groupName == "All") {
                  _vue.basicGroupId.push(result.data[i].groupId);
                }
                if (result.data[i].groupName == "Admins") {
                  //_vue.basicGroupId.push(result.data[i].groupId);
                }

              }
            }
          }




        })
    },
    assignItemToGroup(categoryId) {
      let vue = this;

      let groups = []
      for (let i = 0, lei = this.permissionGroup.length; i < lei; i++) {
        groups.push(this.permissionGroup[i].groupId)
      }

      let obj = {
        objectId: categoryId,
        type: "project category",
        groups: groups
      }
      console.log(obj)
      this.$store.dispatch("u_assignItemToGroup", obj)
        .then((result) => {
          console.log(result.data)

          if (result.status == "OK") {
            if (result.data != null) {

              vue.reloadTree = !vue.reloadTree;



            }
          }

        })
    },
    
    createCategory(){
      
      if (this.categoryName != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }
        let obj = {
          parentId: this.selectedTreeProjectItemObject.categoryId,
          fullPath: this.selectedTreeProjectItemObject.category + "\\" + this.categoryName,
          objAlertSuccess: this.objAlertSuccess,
          objAlertError: this.objAlertError,
          file: file,
          template: this.partNumberTemplate
        }
        
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createCategory", obj)
           .then((result)=>{
              console.log(result.data)
              if(result.data != null){

                vue.categoryName = "";
                vue.inputStatus = null;

                let categoryId = result.data;

                vue.assignItemToGroup(categoryId);
                //vue.reloadTree= !vue.reloadTree;
              }
        })


      }else{

      }

    },
    
    updateCategory(){
      if (this.categoryNameUpdate != ""){

        let file = "";
        
        if (this.file != null){
          
          file = this.file;
        }

        let path = this.selectedTreeProjectItemObject.category;
        let temp = path.split("\\")
        

        let lei = temp.length;
        temp[lei - 1] = this.categoryNameUpdate
        

        let newPath = "";
        for(let i = 0; i < lei; i++ ){
          newPath += temp[i];
          if (i < lei - 1){
            newPath += "\\";
          }
        }

        let categoryId = this.selectedTreeProjectItemObject.categoryId;
        

        let obj = {
          categoryId: categoryId,
          fullPath: newPath,
          objAlertSuccess: this.objAlertSuccessUpdate,
          objAlertError: this.objAlertErrorUpdate,
          file: file,
          template: this.partNumberTemplateUpdate
        }
        console.log(obj)
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateCategory", obj)
           .then((result)=>{
              console.log(result.data)
              if(result.data != null){

                
                vue.assignItemToGroup(categoryId);
                //vue.displayImageCategory(result.data.fileId);

                
              }
        })


      }else{

      }
    }

  },
  
}
</script>

<style scooped>



  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }

  .content .btn{
    margin-left: 5px;

  }
  .content .input-category-name{
     width: 100%;
  }
  .content .input-category-name-update{
     width: 100%;
  }
  .img-fluid {
    max-width: 200px;
    
  }
  .category-image{
    max-width: 200px;
  } 
  

  .info-template{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/Categories/Middle/Content/Content.vue